import React, { useState } from 'react';
import {
	Popover,
	Tabs,
	Tab,
	AppBar,
	Button,
	Box,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import RootCanalOne from './RootCanalOne';
import RootCanalTwo from './RootCanalTwo';
import RootCanalThree from './RootCanalThree';

const sel = document.getElementById('hidden');

const RootCanal = (props) => {
	const theme = useTheme();
	const sx = {
		tabRoot: { minWidth: 100 },
		body: { marginTop: 16, padding: 16 },
		root: { maxWidth: 400, width: 400 },
	};

	const [state, setState] = useState({
		tab: 'one',
		altMode: false,
		restoration: '',
		data: [ ['', '', '', '', ''], ['', '', '', '', ''], ['', '', '', '', ''] ],
	});

	const handleTabChange = (event, value) => setState(s => ({ ...s, tab: value }));

	const update = (data) => setState(s => ({ ...s, ...data }));

	const save = () => {
		const data = { ...(props.state || {}) };
		data.roots = state.tab;
		data.altMode = state.altMode;
		data.restoration = state.restoration;

		switch(state.tab) {
			case 'one':
				data.values = [state.data[0], [], []];
				data.roots = 1;
				break;
			case 'two':
				data.values = [state.data[0], state.data[1], []];
				data.roots = 2;
				break;
			default:
				data.values = [...state.data];
				data.roots = 3;
		}

		props.save && props.save(data);
	};

	return (
		<Popover
			PaperProps={{ sx: sx.root }}
			anchorEl={sel}
			anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
			transformOrigin={{ vertical: 'center', horizontal: 'left' }}
			open={true}
		>
			<AppBar position="static">
				<Tabs value={state.tab} onChange={handleTabChange} variant="fullWidth">
					<Tab sx={sx.tabRoot} label="1 Root" value="one" />
					<Tab sx={sx.tabRoot} label="2 Roots" value="two" />
					<Tab sx={sx.tabRoot} label="3 Roots" value="three" />
				</Tabs>
			</AppBar>

			<Box sx={sx.body}>
				{state.tab === 'one' && <RootCanalOne data={state} update={update} />}
				{state.tab === 'two' && <RootCanalTwo data={state} update={update} />}
				{state.tab === 'three' && <RootCanalThree data={state} update={update} />}
			</Box>

			<Box sx={sx.body}>
				<Button variant="contained" color="secondary" onClick={save}>Done</Button>
			</Box>
		</Popover>
	);
};


export default RootCanal;
